import PropTypes from 'prop-types';
import React, { lazy, Suspense } from 'react';
import { DetectCardNumberType } from '../../../../utils/general';
const Visa = /*#__PURE__*/lazy(() => import('./brands/visa'));
const Mastercard = /*#__PURE__*/lazy(() => import('./brands/mastercard'));
const Amex = /*#__PURE__*/lazy(() => import('./brands/amex'));
const Discover = /*#__PURE__*/lazy(() => import('./brands/discover'));
const brands = [/*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(Visa, null), /*#__PURE__*/React.createElement(Mastercard, null), /*#__PURE__*/React.createElement(Amex, null), /*#__PURE__*/React.createElement(Discover, null)];

function CardBrand({
  cardNumber
}) {
  const cardType = DetectCardNumberType(cardNumber);
  return /*#__PURE__*/React.createElement("div", {
    className: "card-brand"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-type"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null)
  }, brands[cardType])));
}

CardBrand.propTypes = {
  entityType: PropTypes.string
};
export default CardBrand;